import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, message, Row } from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../..";
import { TypesCharacteristicsCreateContext } from "../../context/TypesCharacteristicsCreateContext/TypesCharacteristicsCreateContext";
import { ITypesCharacteristicsCreateContext } from "../../context/TypesCharacteristicsCreateContext/types";
import { TypesCharacteristicsParams } from "../../features/TypesCharacteristicsParams/TypesCharacteristicsParams";
import { TypesCharacteristicsValues } from "../../features/TypesCharacteristicsValues/TypesCharacteristicsValues";
import "./TypesCharacteristicsView.less";
import { TypesCharacteristicsViewContext } from "../../context/TypesCharacteristicsViewContext/TypesCharacteristicsViewContext";
import {
  addValuesTypesCharacteristics,
  deleteAllValuesTypesCharacteristics,
  deleteValuesTypesCharacteristics,
  fetchTypesCharacteristicsSelectValueDic,
  searchTypesCharacteristicsById,
  searchTypesCharacteristicsObject,
} from "../../store/slice/typesCharacteristicsSlice";
import { ITypesCharacteristicsValuesTableRecord } from "../../features/TypesCharacteristicsValues/utils/types";
import { IDeleteValuesTypesCharacteristicsParams } from "../../types/DeleteValuesTypesCharacteristicsParams";
import { IAddValuesTypesCharacteristicsParams } from "../../types/AddValuesTypesCharacteristicsParams";
import { toHttpFormat, toHttpFormatEndOfDay, toHttpFormatStartOfDay } from "../../../../lib/utils";
import { TypesCharacteristicsObjects } from "../../features/TypesCharacteristicsObjects/TypesCharacteristicsObjects";
import { TypeCharacteristic } from "../../types/TypeCharacteristic";

export const TypesCharacteristicsView = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { typesCharacteristicsId } = useParams<{ typesCharacteristicsId: string }>();

  const { typesCharacteristicsById } = useAppSelector((state) => state.typesCharacteristics);

  const [typesCharacteristicsParamsForm] = Form.useForm();

  const [selectedValueTypeId, setSelectedValueTypeId] = useState<number | undefined>(undefined);

  const fetchTypesCharacteristicsById = () => {
    if (typesCharacteristicsId) {
      dispatch(searchTypesCharacteristicsById(typesCharacteristicsId));
      dispatch(
        searchTypesCharacteristicsObject({
          charTypeIds: [Number(typesCharacteristicsId)],
          onDate: toHttpFormat(moment()),
        })
      );
    }
  };

  // Загрузка типа характеристики по входу
  useEffect(() => {
    fetchTypesCharacteristicsById();

    return () => {
      setSelectedValueTypeId(undefined);
    };
  }, []);

  // Загрузка справочника значений
  useEffect(() => {
    if (typesCharacteristicsById && typesCharacteristicsById.valueDicTypeAlias) {
      dispatch(fetchTypesCharacteristicsSelectValueDic(typesCharacteristicsById.valueDicTypeAlias));
      setSelectedValueTypeId(typesCharacteristicsById?.charTypeValues[0]?.valueTypeId);
    }
  }, [typesCharacteristicsById]);

  const contextValue: ITypesCharacteristicsCreateContext = {};

  const [tableData, setTableData] = useState<ITypesCharacteristicsValuesTableRecord[]>([]);

  const onFinish = (fields) => {};

  const deletedSavedRecord = (record: ITypesCharacteristicsValuesTableRecord) => {
    if (typesCharacteristicsById) {
      message.destroy();
      message.loading("Удаление");
      dispatch(
        deleteValuesTypesCharacteristics({
          charTypeId: typesCharacteristicsById.id,
          charTypeValueId: record.id,
        })
      ).then((res) => {
        if (res.payload !== undefined) {
          setTableData((prev) => prev.filter((item) => item.key !== record.key));
        } else {
          message.destroy();
        }
      });
    }
  };

  const deletedAllSavedRecord = (typeCharacteristic: TypeCharacteristic) => {
    if (typesCharacteristicsById) {
      message.destroy();
      message.loading("Удаление");
      dispatch(
        deleteAllValuesTypesCharacteristics({
          charTypeId: typeCharacteristic.id,
        })
      ).then((res) => {
        if (res.payload !== undefined) {
          setTableData([]);
        } else {
          message.destroy();
        }
      });
    }
  };

  const addSavedRecord = (record: ITypesCharacteristicsValuesTableRecord) => {
    if (typesCharacteristicsById) {
      typesCharacteristicsParamsForm.validateFields().then(() => {
        message.destroy();
        message.loading("Сохранение");

        const params: IAddValuesTypesCharacteristicsParams = {
          charTypeId: typesCharacteristicsById.id,
          body: [],
        };

        const fields = typesCharacteristicsParamsForm.getFieldsValue();

        if (
          typesCharacteristicsById.dataTypeId !== 4 &&
          typesCharacteristicsById.dataTypeId !== 3
        ) {
          params.body = [
            {
              valueTypeId: Number(fields.valueTypeId),
              unitTypeId: Number(fields[`${record.key}_unitTypeId`]) || undefined,
              rangeTypeId: Number(fields[`${record.key}_rangeTypeId`]) || undefined,
              value: fields[`${record.key}_value`],
              valueTo: fields[`${record.key}_valueTo`],
            },
          ];
        }

        if (typesCharacteristicsById.dataTypeId === 3) {
          params.body = [
            {
              valueTypeId: Number(fields.valueTypeId),
              unitTypeId: Number(fields[`${record.key}_unitTypeId`]) || undefined,
              rangeTypeId: Number(fields[`${record.key}_rangeTypeId`]) || undefined,
              value: toHttpFormatStartOfDay(fields[`${record.key}_value`]),
              valueTo: fields[`${record.key}_valueTo`]
                ? toHttpFormatEndOfDay(fields[`${record.key}_valueTo`])
                : undefined,
            },
          ];
        }

        if (typesCharacteristicsById.dataTypeId === 4) {
          const charTypeValuesFormat: IAddValuesTypesCharacteristicsParams["body"] = [];

          if (Number(fields.valueTypeId) === 1) {
            if (Array.isArray(fields[`${record.key}_value`])) {
              fields[`${record.key}_value`].forEach((value) => {
                charTypeValuesFormat.push({
                  valueTypeId: Number(fields.valueTypeId),
                  unitTypeId: Number(fields[`${record.key}_unitTypeId`]) || undefined,
                  rangeTypeId: Number(fields[`${record.key}_rangeTypeId`]) || undefined,
                  value,
                  valueTo: fields[`${record.key}_valueTo`],
                });
              });
            }
          } else {
            charTypeValuesFormat.push({
              valueTypeId: Number(fields.valueTypeId),
              unitTypeId: Number(fields[`${record.key}_unitTypeId`]) || undefined,
              rangeTypeId: Number(fields[`${record.key}_rangeTypeId`]) || undefined,
              value: fields[`${record.key}_value`],
              valueTo: fields[`${record.key}_valueTo`],
            });
          }

          params.body = charTypeValuesFormat;
        }

        dispatch(addValuesTypesCharacteristics(params)).then((res) => {
          if (res.payload !== undefined) {
            fetchTypesCharacteristicsById();
          } else {
            message.destroy();
          }
        });
      });
    }
  };

  return (
    <TypesCharacteristicsViewContext.Provider value={contextValue}>
      <div className="types-characteristics-view">
        <Row className="types-characteristics-view-title" align="middle">
          <Link to="/types-characteristics">
            <LeftOutlined style={{ fontSize: 16 }} />
          </Link>

          <h1>Просмотр типа характеристики</h1>

          <Divider className="types-characteristics-view-divider" />
        </Row>

        <Form
          form={typesCharacteristicsParamsForm}
          onFinish={onFinish}
          labelAlign="left"
          initialValues={{
            contextId: 1,
            statusId: 0,
          }}
          style={{ width: "100%" }}
        >
          <TypesCharacteristicsParams
            mode="view"
            typeCharacteristic={typesCharacteristicsById}
            typesCharacteristicsParamsForm={typesCharacteristicsParamsForm}
          />

          <Divider
            className="types-characteristics-view-divider"
            style={{ marginTop: "-10px", marginBottom: 0 }}
          />

          <TypesCharacteristicsValues
            mode="view"
            typeCharacteristic={typesCharacteristicsById}
            tableData={tableData}
            setTableData={setTableData}
            typesCharacteristicsParamsForm={typesCharacteristicsParamsForm}
            deletedSavedRecord={deletedSavedRecord}
            addSavedRecord={addSavedRecord}
            selectedValueTypeId={selectedValueTypeId}
            setSelectedValueTypeId={setSelectedValueTypeId}
            deletedAllSavedRecord={deletedAllSavedRecord}
          />

          <Divider
            className="types-characteristics-view-divider"
            style={{ marginTop: "20px", marginBottom: 4 }}
          />

          <TypesCharacteristicsObjects charTypeId={typesCharacteristicsById?.id} />
        </Form>
      </div>
    </TypesCharacteristicsViewContext.Provider>
  );
};

export default TypesCharacteristicsView;
